import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';

export class AnswerApiService {
  private readonly answerBaseUrl: string;

  constructor() {
    this.answerBaseUrl = ApiConstants().answer;
  }

  async getUserAnswersByThemeId(
    themeId: string,
    type: 'start' | 'end',
  ): Promise<AxiosResponse> {
    return await request({
      url: `${this.answerBaseUrl}by-user-theme?themeId=${themeId}&type=${type}`,
      method: 'GET',
      requiresToken: true,
    });
  }
}
